import { Plan } from "../Plan";

export class MockPlan implements Plan {
  public name = "name";
  public id: string;
  public currency = "€";
  public price = 1999;
  public interval = "interval";
  public intervalCount = 1;
  public trialPeriodDays = 14;
  public description = "description";
  public offerName = "offerName";
  public default?: boolean | undefined;
  public publicId = "publicId";
  public playedTimeLeft = 30;
  public type = "type";
  public formattedPrice = "formattedPrice";
  public billingPeriod = "monthly";
  public paymentDescription?: string | undefined;
  public title?: string | undefined;
  public startDate?: string | undefined;
  public currentPeriodEndDate?: string | undefined;
  public formattedProrata?: string | undefined;
  public nextperiodEndDate?: string | undefined;
  public prorata?: string | undefined;
  private static INDEX = 0;

  constructor() {
    MockPlan.INDEX++;
    this.id = `${MockPlan.INDEX}`;
  }
}
